import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import RootState from '../../../../redux/types';
import { requestVirtualTerminal } from '../../../../redux/insight';
import DashboardLayout from '../../../../layout/dashboard/DashboardLayout';
import TitleTextBox from '../../../../fragments/TitleTextBox';
import ContainerWrapper from '../../../../fragments/ContainerWrapper';
import { formatCamelCase } from '../../../../utils/helpers';
import { RavenButton } from '@ravenpay/raven-bank-ui';
import roundBankbox from "../../../../assets/round bankbox.png"
import { RouteLinks } from '../../../../routes/RouteLinks';
const ShowRequestVirtualTerminalDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const requestObject = location.state;
    const { loading } = useSelector(
      (state: RootState) => state.insights
    );
    const handleRequestVirtualTerminal = async () => {
        const obj = {
          label: requestObject.terminalLabel,
          account_number: requestObject.accountNo,
          purpose: requestObject.purpose,
          
        };
        const data = await dispatch(requestVirtualTerminal(obj as any) as any);
        // console.log("this is dataaaaaa", data);
    
        if (data?.payload?.status === "success") {
         
          navigate(RouteLinks.Terminals_Virtual);
       
        }
        else{
          navigate(`${RouteLinks.Request_Terminal}?view=virtual`);
        }
      };
    return (
        <>
          <DashboardLayout>
            <TitleTextBox
              text="Power your business with a strong toolkit designed for growth"
              title="Request a Terminal"
              back
              onBack={() => {
                navigate(-1);
              }}
            ></TitleTextBox>
            <ContainerWrapper
              width={`100%`}
              className="container-wrapper-cont"
              dontShowHeader
            >
              <div className="request-terminal-detail-general-div-container">
                <div className="bank-box-image-holder">
                  <figure>
                    <img src={roundBankbox} alt="bank-box" />
                  </figure>
                </div>
                <div className="request-terminal-detail-general-div">
                 
                  <div className="request-terminal-detail-general-div-body">
                    {Object.entries(requestObject).map(([key, value], index) => (
                      <div className="request-details-card">
                        <p className="request-detail-name">
                          {formatCamelCase(key)}
                        </p>
                        <p className="request-detail-value">{String(value)}</p>
                      </div>
                    ))}
                  </div>
                </div>
    
                <RavenButton
                  color="deep-green-light"

                  label="Request Terminal"
                  className="reques-raven-submit-button"
                  onClick={handleRequestVirtualTerminal}
                  loading={loading}
                />
              </div>
            </ContainerWrapper>
          </DashboardLayout>
        </>
      );
}

export default ShowRequestVirtualTerminalDetails